module.exports = __webpack_public_path__ + "static/media/picture-(135).83d04ba2.JPG";